<div>
  <div class="guts-p-b-1-half">
    <h3 class="h3">{{ i18n.Core_Activity }}</h3>
  </div>

  <div class="profile-activity-section-nav">
    <ul>
      <ng-container
        *ngFor="let countType of config; let first = first; let last = last"
        data-dgat="profile-activity-27e"
      >
        <li
          class="profile-activity-section-nav__item guts-p-h-1-half"
          [ngClass]="{
            'guts-p-t-1-half': first,
            'guts-p-t-1': !first,
            'guts-p-b-1': !last,
            'guts-p-b-1-half': last
          }"
        >
          <div class="l_flex l_flex-row l_flex-justify">
            <div class="par par--small par--light_a">
              {{ countType[0] }}
            </div>
            <div class="badge badge-pill badge-neutral">{{ countType[1] }}</div>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
